<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
// import idleTimeout from 'idle-timeout'
import EventBus from '@/event/event-bus'
// import { whiteList } from '@/permission'

export default {
  name: 'App',

  instance: null,

  created() {
    //  if (process.env.NODE_ENV !== 'development') {
    //   window.addEventListener('beforeunload', this.unloadLogout)
    //   this.instance = idleTimeout(() => {
    //     console.log('[INFO] Idle timeout triggered')
    //     this.logout()
    //   },
    //   {
    //     element: document,
    //     timeout: 10 * 1000,
    //     loop: false
    //   })
    //  }
  },

  updated() {
    // if (process.env.NODE_ENV !== 'development') {
    //   if (whiteList.includes(this.$route.name)) {
    //     console.log('[INFO] Idle timeout paused')
    //     this.instance.pause()
    //   } else {
    //     console.log('[INFO] Idle timeout started')
    //     this.instance.reset()
    //   }
    // }
  },

  methods: {
    unloadLogout(e) {
      this.$store.dispatch('LogOut')
      return e
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        EventBus.$emit('closeSocket')
        this.$store.dispatch('ResetRouters').then(() => {
          this.$router.replace({ name: 'Login', query: { timeout: 1 }})
        })
      })
    }
  }
}
</script>

<style lang="scss">
  .grecaptcha-badge {
    visibility: hidden;
  }
  
  .el-button--primary {
    color: #fff;
    background-color: #0972ce;
    border-color: #0972ce;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue